import {
  DatabaseTwoTone,
  PieChartTwoTone,
  SmileTwoTone,
} from "@ant-design/icons";

const defaultProps = {
  route: {
    path: "/",
    routes: [
      {
        path: "/welcome",
        name: "灰度发布",
        icon: <SmileTwoTone />,
        component: "./Welcome",
      },
      {
        path: "/ip",
        name: "IP列表",
        icon: <DatabaseTwoTone />,
        component: "./IpList",
      },
      {
        path: "/version",
        name: "版本信息",
        icon: <PieChartTwoTone />,
        component: "./Version",
      },
    ],
  },
  location: {
    pathname: "/",
  },
  title: "Grayscale-Publish",
};

export default defaultProps;
